import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { translations } from "../lib/i18n";
import { langFromPath } from "../lib/routing";

const I18nContext = createContext();

/**
 * El idioma sale de la URL (/en/... = inglés, el resto español).
 *
 * Antes salía de localStorage/navigator, así que ES y EN vivían en la misma URL y
 * Google sólo podía indexar una de las dos versiones — la traducción al inglés
 * existía pero era invisible para el buscador. Ahora cada idioma tiene su URL y
 * el cambio de idioma es una navegación (ver LanguageToggle).
 *
 * Debe montarse DENTRO de <BrowserRouter> porque usa useLocation.
 */
export function I18nProvider({ children }) {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, t: translations[lang] }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
